import { render } from "./ValueStoryROISection.vue?vue&type=template&id=3bc4b376&scoped=true"
import script from "./ValueStoryROISection.vue?vue&type=script&lang=js"
export * from "./ValueStoryROISection.vue?vue&type=script&lang=js"

import "./ValueStoryROISection.vue?vue&type=style&index=0&id=3bc4b376&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc4b376"]])

export default __exports__